var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "flex content-center items-center",
      class: {
        "flex-col": !_vm.labelHorizontal,
      },
    },
    [
      _vm.labelLeft
        ? _c("label", { class: _vm.labelClass, attrs: { for: _vm.id } }, [
            _vm._v(" " + _vm._s(_vm.label) + " "),
          ])
        : _vm._e(),
      _c(
        "span",
        {
          staticClass:
            "group relative inline-flex items-center justify-center flex-shrink-0 h-5 w-10 cursor-pointer focus:outline-none",
          attrs: {
            role: "checkbox",
            tabindex: "0",
            id: _vm.id,
            "aria-checked": String(_vm.checked),
          },
          on: {
            click: function ($event) {
              return _vm.toggle()
            },
            keydown: function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "space", 32, $event.key, [
                  " ",
                  "Spacebar",
                ])
              )
                return null
              $event.preventDefault()
              return _vm.toggle()
            },
          },
        },
        [
          _c("span", {
            staticClass:
              "absolute toggleHeight w-10 mx-auto rounded-full transition-colors ease-in-out duration-200",
            class: _vm.secondaryToggleClasses,
            attrs: { "aria-hidden": "true" },
          }),
          _c("span", {
            staticClass:
              "absolute left-0 inline-block h-4 w-5 rounded-full bg-white shadow transform group-focus:shadow-outline-white group-focus:border-white transition-transform ease-in-out duration-200",
            class: _vm.primaryToggleClasses,
            attrs: { "aria-hidden": "true" },
          }),
        ]
      ),
      !_vm.labelLeft
        ? _c(
            "label",
            {
              class: _vm.labelClass,
              attrs: { for: _vm.id },
              on: {
                click: function ($event) {
                  return _vm.toggle()
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.label) + " ")]
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }